<template>
    <div v-if="coverageCollectingRate && globalScanRate && campaignProgressRate" class="row">
        <div class="col-lg-3 col-12 pr-lg-4" v-if="!this.campaignWithOutBags">
        <div class="card p-3 text-center " style="border:1px solid #ddd;">
          <h5 class="text-dark text-uppercase mb-1">{{ $t('campaign.card.campaignProgress') }}</h5>
          <span class="text-dark mb-1">sacs distribués / Sacs</span>
          <div class="circular-border">
            <svg viewBox="0 0 36 36" width="100%" height="100%">
              <path
                class="circle-bg"
                d="M18 2.0845A15.9155 15.9155 0 0 0 2.0845 18 15.9155 15.9155 0 0 0 18 33.9155 15.9155 15.9155 0 0 0 33.9155 18 15.9155 15.9155 0 0 0 18 2.0845"
              />
              <path
                class="circle"
                :stroke-dasharray="getDashArray(campaignProgressRate.coverageRate)"
                d="M18 2.0845A15.9155 15.9155 0 0 0 2.0845 18 15.9155 15.9155 0 0 0 18 33.9155 15.9155 15.9155 0 0 0 33.9155 18 15.9155 15.9155 0 0 0 18 2.0845"
              />
              <text class="percentage-text" x="52%" y="52%" text-anchor="middle" alignment-baseline="middle">
                {{ campaignProgressRate.coverageRateAsString }}
              </text>
            </svg>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-12 mt-4 mt-lg-0 pl-lg-4 pr-lg-4" v-if="!this.campaignWithOutBags">
        <div class="card p-3 text-center text-dark " style="border:1px solid #ddd;">
          <h5 class="text-dark text-uppercase mb-1">{{ $t('campaign.card.globalScanRate') }}</h5>
          <span class="text-dark mb-1">QR codes scannés / Sacs distribués</span>
          <div class="circular-border">
            <svg viewBox="0 0 36 36"  width="100%" height="100%">
              <path
                class="circle-bg"
                d="M18 2.0845A15.9155 15.9155 0 0 0 2.0845 18 15.9155 15.9155 0 0 0 18 33.9155 15.9155 15.9155 0 0 0 33.9155 18 15.9155 15.9155 0 0 0 18 2.0845"
              />
              <path
                class="circle-blue"
                :stroke-dasharray="getDashArray(globalScanRate.coverageRate)"
                d="M18 2.0845A15.9155 15.9155 0 0 0 2.0845 18 15.9155 15.9155 0 0 0 18 33.9155 15.9155 15.9155 0 0 0 33.9155 18 15.9155 15.9155 0 0 0 18 2.0845"
              />
              <text class="percentage-text-blue" x="52%" y="52%" text-anchor="middle" alignment-baseline="middle">
                {{ globalScanRate.coverageRateAsString }}
              </text>
            </svg>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-12 mt-4 mt-lg-0 pl-lg-4 pr-lg-4" v-if="!this.campaignWithOutBags">
        <div class="card p-3 text-center text-dark " style="border:1px solid #ddd;">
          <h5 class="text-dark text-uppercase mb-1">{{ $t('campaign.card.globalScanRateUnique') }}</h5>
          <span class="text-dark mb-1">Scans uniques / Sacs distribués</span>
          <div class="circular-border" >
            <svg v-if="globalScanRate.uniqueCoverageRate" viewBox="0 0 36 36"  width="100%" height="100%">
              <path
                class="circle-bg"
                d="M18 2.0845A15.9155 15.9155 0 0 0 2.0845 18 15.9155 15.9155 0 0 0 18 33.9155 15.9155 15.9155 0 0 0 33.9155 18 15.9155 15.9155 0 0 0 18 2.0845"
              />
              <path
                class="circle-blue"
                :stroke-dasharray="getDashArray(globalScanRate.uniqueCoverageRate)"
                d="M18 2.0845A15.9155 15.9155 0 0 0 2.0845 18 15.9155 15.9155 0 0 0 18 33.9155 15.9155 15.9155 0 0 0 33.9155 18 15.9155 15.9155 0 0 0 18 2.0845"
              />
              <text class="percentage-text-blue" x="52%" y="52%" text-anchor="middle" alignment-baseline="middle">
                {{ globalScanRate.uniqueCoverageRateAsString }}
              </text>
            </svg>
            <div v-else class="d-flex justify-content-center align-items-center text-secondary h-100" >Pas de données</div>
          </div>
        </div>
      </div>
      <div class="mt-4 mt-lg-0 " :class="this.campaignWithOutBags ? 'col-12': 'col-lg-3 col-12  pl-lg-4'">
        <div class="card p-3 text-center" style="border:1px solid #ddd;">
          <h5 class="text-dark text-uppercase mb-1">{{ $t('campaign.card.coverageCollectingRate') }}</h5>
          <span class="text-dark mb-1">Données collectées / QR codes scannés</span>

          <div  class="circular-border">
            <svg v-if="coverageCollectingRate.coverageRate" viewBox="0 0 36 36"  width="100%" height="100%">
              <path
                class="circle-bg"
                d="M18 2.0845A15.9155 15.9155 0 0 0 2.0845 18 15.9155 15.9155 0 0 0 18 33.9155 15.9155 15.9155 0 0 0 33.9155 18 15.9155 15.9155 0 0 0 18 2.0845"
              />
              <path
                class="circle-red"
                :stroke-dasharray="getDashArray(coverageCollectingRate.coverageRate)"
                d="M18 2.0845A15.9155 15.9155 0 0 0 2.0845 18 15.9155 15.9155 0 0 0 18 33.9155 15.9155 15.9155 0 0 0 33.9155 18 15.9155 15.9155 0 0 0 18 2.0845"
              />
              <text class="percentage-text-red" x="52%" y="52%" text-anchor="middle" alignment-baseline="middle">
                {{ coverageCollectingRate.coverageRateAsString }}
              </text>
            </svg>
            <div v-else class="d-flex justify-content-center align-items-center text-secondary h-100" >Pas de collecte de données</div>

          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Vue from 'vue';
  import VueApexCharts from 'vue-apexcharts';
  
  Vue.component('apexchart', VueApexCharts);
  
  export default {
    props: {
      campaignWithOutBags:{
        type: Boolean,
        default: false,
      },
      coverageCollectingRate: {
        type: Object,
        default: () => null,
      },
      globalScanRate: {
        type: Object,
        default: () => null,
      },
      campaignProgressRate: {
        type: Object,
        default: () => null,
      },
    },
    methods: {
      getDashArray(rate) {
        const numericRate = parseFloat(rate);
        const radius = 15.9155
        const circumference = 2 * Math.PI * radius;
        const dashArray = `${(circumference * numericRate) / 100} ${circumference}`;
        return dashArray;
      }
    },
  };
  </script>
  
  <style scoped>
  .card {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    text-align: center;
  }
  
  h5 {
    font-weight: bold;
  }
  
  .circular-border {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 120px;
    margin: 0 auto; /* Center the circular-border within the card */
  }
  
  .circle-bg {
    fill: none;
    stroke: #e6e6e6;
    stroke-width: 1;
  }
  
  .circle {
    fill: none;
    stroke: #137437;
    stroke-width: 1.5;
    transition: stroke-dasharray 0.5s ease;
  }
  
  .percentage-text {
    font-size: 7px;
    fill: #137437;
    dominant-baseline: middle;
    text-anchor: middle;
    padding:150px;
  }

  .circle-red {
    fill: none;
    stroke: #F44336;
    stroke-width: 1.5;
    transition: stroke-dasharray 0.5s ease;
  }
  
  .percentage-text-red {
    font-size: 7px;
    fill: #F44336;
    dominant-baseline: middle;
    text-anchor: middle;
    
  }


  .circle-blue {
    fill: none;
    stroke: #29B6F6;
    stroke-width: 1.5;
    transition: stroke-dasharray 0.5s ease;
  }
  
  .percentage-text-blue {
    font-size: 7px;
    fill: #29B6F6;
    dominant-baseline: middle;
    text-anchor: middle;
  }
  </style>
  